export default "__VITE_ASSET__fh23nbp4__"